import CarouselTabsItems from "@/assets/plugins/carousel-tabs-items/CarouselTabsItems";

export default {
    install(Vue, options) {
        Vue.component("CarouselTabsItems", CarouselTabsItems);
    }
}
